/**
 * Пагинация ленты новостей (кнопка "Load more").
 * См. completed_projects.js — тот же паттерн.
 */

const PAGINATION_CONTAINER = '#news_list_outer';
const PAGINATION_BUTTON = '#news_pagination_button';
const TOTAL_PAGES = 3;

let pageCounter = 1;

async function loadNextPage() {
    pageCounter++;
    const container = document.querySelector(PAGINATION_CONTAINER);
    const button = document.querySelector(PAGINATION_BUTTON);

    try {
        const response = await fetch('/html_complete/inc/ajax/ajax_news.php');
        if (response.ok) {
            const html = await response.text();
            const list = container?.querySelector('.content_list');
            if (list) list.insertAdjacentHTML('beforeend', html);
        }
    } catch (e) {
        console.error('Load more (news) failed:', e);
    }

    if (pageCounter >= TOTAL_PAGES && button?.parentElement) {
        button.parentElement.style.display = 'none';
    }
}

function init() {
    document.addEventListener('click', e => {
        if (e.target.closest(PAGINATION_BUTTON)) loadNextPage();
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
